// extracted by css-extract-rspack-plugin
export default {"ErrorFlash":"ChecksGroup-module__ErrorFlash__rUxGL","ErrorOcticon":"ChecksGroup-module__ErrorOcticon__GBj8Z"};